/* tslint:disable */

declare var Object: any;
export interface ExpenseLineItemInterface {
  "sfdcId"?: string;
  "Amount__c"?: number;
  "Amount_USD__c"?: number;
  "CreatedBy__c"?: string;
  "Category__c"?: string;
  "Description__c"?: string;
  "Expense_Date__c"?: Date;
  "Expense_Receipt__c"?: string;
  "LastModifiedById"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "Name"?: string;
  "LastModifiedBy__c"?: string;
  "CreatedDate"?: Date;
  "IsDeleted"?: boolean;
  "LastModifiedDate"?: Date;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class ExpenseLineItem implements ExpenseLineItemInterface {
  "sfdcId": string;
  "Amount__c": number;
  "Amount_USD__c": number;
  "CreatedBy__c": string;
  "Category__c": string;
  "Description__c": string;
  "Expense_Date__c": Date;
  "Expense_Receipt__c": string;
  "LastModifiedById": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "Name": string;
  "LastModifiedBy__c": string;
  "CreatedDate": Date;
  "IsDeleted": boolean;
  "LastModifiedDate": Date;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ExpenseLineItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ExpenseLineItem`.
   */
  public static getModelName() {
    return "ExpenseLineItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ExpenseLineItem for dynamic purposes.
  **/
  public static factory(data: ExpenseLineItemInterface): ExpenseLineItem{
    return new ExpenseLineItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ExpenseLineItem',
      plural: 'ExpenseLineItems',
      path: 'ExpenseLineItems',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Amount__c": {
          name: 'Amount__c',
          type: 'number'
        },
        "Amount_USD__c": {
          name: 'Amount_USD__c',
          type: 'number'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "Category__c": {
          name: 'Category__c',
          type: 'string'
        },
        "Description__c": {
          name: 'Description__c',
          type: 'string'
        },
        "Expense_Date__c": {
          name: 'Expense_Date__c',
          type: 'Date'
        },
        "Expense_Receipt__c": {
          name: 'Expense_Receipt__c',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
